import * as React from 'react';

import './HeaderUIStyle.scss';
import logo from '../../images/logo_chelsea.png';

class HeaderUI extends React.Component<{}, {}> {

    public render() {
        return (
            <div className="header">
                <div className="headerStrip"></div>
                <div className="headerBody">
                    <div className="headerLeft"><a href="https://www.chelseafc.com/" target="_blank" rel="noreferrer"><img className="imgLogo" src={logo} alt="" /></a></div>
                    <div className="headerRight"></div>
                </div>
                <div className="headerBottom"></div>
            </div>
        );
    }

}

export default HeaderUI;